module.exports = __webpack_public_path__ + "media/images/icons/dolly-6cb9038130ebda296c76373cbf7a1068.svg";